import { Bridge, useSuperIntl } from "./_";
import React from 'react';
export var SuperTitle = function SuperTitle(properties) {
  var _Bridge$useAppData = Bridge.useAppData(),
    clientRoutes = _Bridge$useAppData.clientRoutes;
  var intl = useSuperIntl();
  var _Bridge$useLocation = Bridge.useLocation(),
    pathname = _Bridge$useLocation.pathname;
  var route = Bridge.matchRoutes(clientRoutes, pathname.split('/').slice(0, 3).join('/')).at(-1) || {
    pathname: ''
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      fontSize: 16,
      fontWeight: 500,
      color: '#181A1D',
      alignItems: 'center',
      margin: '8px 0 24px 0'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: route.pathname,
    src: "/statics/images/illustrations".concat(route.pathname, ".svg"),
    style: {
      width: 40,
      marginRight: '12px',
      verticalAlign: 'middle',
      marginLeft: properties.collapsed ? -8 : 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: 'normal'
    }
  }, properties.collapsed || intl.formatMessage({
    id: "menu".concat(route.pathname.replaceAll('/', '.'))
  })));
};